import {FETCH_GANTT_PROJECT, FETCH_GANTT_PROJECT_FAIL, IS_LOADING_GANTT_PROJECT} from "../actionTypes";
import api from '../../../services/instanceapi'
import {ganttProjectsURL} from "../../../services/api";

export const loadProjectGantt = (project_id) => async (dispatch) => {
    dispatch({
        type: IS_LOADING_GANTT_PROJECT
    })
    try {
        const {data: {id, name, endDate, startDate, actions}} = await api.get(ganttProjectsURL(project_id))
        dispatch({
            type: FETCH_GANTT_PROJECT,
            payload: {
                id: id,
                name: name,
                endDate: endDate,
                startDate: startDate,
                actions: actions
            }
        })
    } catch (e) {
        dispatch({
            type: FETCH_GANTT_PROJECT_FAIL,
        })
    }
}